import React from "react";
import "./Newlivia.scss";
import Comingsoon from "../../Media/Livia_Desktop.webp";
import Soon from "../../Media/Livia_Mobile.webp";

const handleConsultationClick = () => {
  const whatsappLink =
    "https://api.whatsapp.com/send/?phone=6287876666122&text=Halo%20Anggi,%20Saya%20bisa%20minta%20detail%20Katalog,%20Simulasi,%20dan%20Promo%20terbaru%20Produk%20Grand%20Wisata%20(Livia%20Ladoria)%20https://perumahan-grand-wisata.com//&type=phone_number&app_absent=0";
  window.open(whatsappLink, "_blank");
};

const soon = () => {
  return (
    <div id="flashsale" className="container-soon">
      <div className="louise">
        <h1>New Launching Grand Wisata</h1>
        <h2> Livia at Ladoria</h2>
      </div>
      <div className="maps-lokasi">
        <img
          id="location"
          className="img-lokasi-dekstop"
          src={Comingsoon}
          alt="maps"
        />
        <img id="lokasi" className="img-lokasi-mobile" src={Soon} alt="maps" />
      </div>
      <div className="button">
        <div className="container-wa">
          <button className="buttonpenawaran" onClick={handleConsultationClick}>
            More Info
          </button>
        </div>
      </div>
    </div>
  );
};

export default soon;
